export default __webpack_public_path__ + "static/media/envelope.b7331ecc.svg";